angular
    .module('festzelt-os.vouchers')
    .config([
        '$stateProvider',
        config
    ]);

function config($stateProvider) {
    $stateProvider
        .state('app.vouchers', {
            abstract: true,
            url: '/vouchers',
            template: '<ui-view/>'
        });
}



// WEBPACK FOOTER //
// ./src/app/pages/vouchers/vouchers-routes.js